import { useMemo } from 'react';
import moment from 'moment';
import dompurify from 'dompurify';

interface TextPopupProps {
  popupData: PopupInfoDetailResDto;
  onCloseWithReadPopup: () => void;
  onClose: () => void;
}

const TextPopup = ({ popupData, onCloseWithReadPopup, onClose }: TextPopupProps) => {
  const sanitizedContents = useMemo(() => dompurify.sanitize(popupData.contents ?? ''), [popupData.contents]);

  return (
    <div className="text_popup">
      <div className="popup_dim"></div>
      <div className="popup_inner">
        <div className="popup_header">
          <h2>{popupData.title}</h2>
          <p>게시일 : {moment(popupData.displayedDt).format('YYYY. MM. DD')}</p>
        </div>
        <div className="popup_body">
          <div className="popup_editor_content" dangerouslySetInnerHTML={{ __html: sanitizedContents }} />
        </div>
        <div className="popup_footer">
          <button type="button" onClick={() => onCloseWithReadPopup()}>
            하루동안 보지 않기
          </button>
          <button type="button" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default TextPopup;
